// extracted by mini-css-extract-plugin
export default {"searchForm":"NewsForm_searchForm__kEdWz","searchInput":"NewsForm_searchInput__r34BM","searchBtn":"NewsForm_searchBtn__GmGAp","searchIcon":"NewsForm_searchIcon__2xEUq"};